import { Component, OnInit } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatTabsModule } from '@angular/material/tabs';
import { RouterLink } from '@angular/router';
import { PrivacyPolicyService } from '../../services/privacy-policy/privacy-policy.service';
import { ContentRenderingService } from '../../services/content-rendering/content-rendering.service';

@Component({
  selector: 'app-privacy-policy',
  standalone: true,
  imports: [MatTabsModule, MatButtonModule, MatIconModule, RouterLink],
  templateUrl: './privacy-policy.component.html',
  styleUrl: './privacy-policy.component.scss',
})
export class PrivacyPolicyComponent implements OnInit {
  data: any;
  loadingData: boolean = true;

  constructor(
    private dataService: PrivacyPolicyService,
    private contentRendering: ContentRenderingService
  ) {}

  ngOnInit(): void {
    this.loadingData = true;
    this.dataService.getPrivacyPolicyData().subscribe({
      next: (res) => {
        this.parseData(res.responseData);
      },
      error: (err) => {
        console.log(err);
      },
      complete: () => {
        this.loadingData = false;
      },
    });
  }

  // for integration: wrap this function and the functions inside, in a Promise
  parseData(data: any) {
    const tncData = data
      .filter((item: any) => item.page === 'TERMS_AND_CONDITION')
      .sort((a: any, b: any) => a.sequence - b.sequence)
      .map((item: any) => {
        return {
          ...item,
          rawTitle: item?.title || '',
          title: this.contentRendering.sanitizeHtml(
            this.addFormatting(item?.title)
          ),
          description: this.contentRendering.sanitizeHtml(
            this.addFormatting(item?.description)
          ),
        };
      });
    const ppData = data
      .filter((item: any) => item.page === 'PRIVACY_POLICY')
      .sort((a: any, b: any) => a.sequence - b.sequence)
      .map((item: any) => {
        return {
          ...item,
          rawTitle: item?.title || '',
          title: this.contentRendering.sanitizeHtml(
            this.addFormatting(item?.title)
          ),
          description: this.contentRendering.sanitizeHtml(
            this.addFormatting(item?.description)
          ),
        };
      });

    this.data = {
      tncData: tncData,
      ppData: ppData,
    };

    console.log(this.data);
  }

  addFormatting(text: string) {
    let tempHtmlElement = text;
    tempHtmlElement = this.contentRendering.addNewLines(tempHtmlElement);
    tempHtmlElement = this.contentRendering.formatBoldText(tempHtmlElement);
    tempHtmlElement = this.contentRendering.addHyperlinks(tempHtmlElement);
    tempHtmlElement = this.contentRendering.addBullets(tempHtmlElement);
    return tempHtmlElement;
  }

  generateAutomationId(title: string): string {
    if (!title) return '';
    // Remove HTML tags and convert to lowercase
    const cleanTitle = title.replace(/<[^>]*>/g, '').toLowerCase();
    // Replace spaces and special characters with underscores
    return cleanTitle
      .replace(/[^a-z0-9]+/g, '_')
      .replace(/^_+|_+$/g, '');
  }

  public ELEMENT_IDS = ELEMENT_IDS;
}

const BASE_ELEMENT_ID: string = 'id_privacy_policy';
export const ELEMENT_IDS: { [key: string]: string } = {
  'page': BASE_ELEMENT_ID + '_page',
  'header': BASE_ELEMENT_ID + '_header',
  'btn_back': BASE_ELEMENT_ID + '_btn_back',
  'lbl_title': BASE_ELEMENT_ID + '_lbl_title',
  'tab_terms_and_conditions': BASE_ELEMENT_ID + '_tab_terms_and_conditions',
  'tab_privacy_policy': BASE_ELEMENT_ID + '_tab_privacy_policy',
  'cnt_terms_and_conditions': BASE_ELEMENT_ID + '_cnt_terms_and_conditions',
  'cnt_privacy_policy': BASE_ELEMENT_ID + '_cnt_privacy_policy',
};
